import Route from '@ember/routing/route';
import type Transition from '@ember/routing/transition';
import { type Registry as Services, service } from '@ember/service';

export default class StartRecordingRoute extends Route {
  @service declare router: Services['router'];

  beforeModel(transition: Transition): void {
    // Start recording
    // TODO: add Sentry recoding logic here

    // Transition to app index
    transition.abort();
    this.router.transitionTo('application');
  }
}
